import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-item-empty-panel" }
const _hoisted_2 = { class: "p-item-empty-panel__heading" }
const _hoisted_3 = { class: "p-form-button-group__vertical p-item-empty-panel__button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHeartOutline = _resolveComponent("IconHeartOutline")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconHistory = _resolveComponent("IconHistory")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("template", null, [
      (_ctx.type === 'favorite')
        ? (_openBlock(), _createBlock(_component_IconBase, {
            key: 0,
            width: _ctx.favoriteIconSize.width,
            height: _ctx.favoriteIconSize.height,
            "view-box": `0 0 ${_ctx.favoriteIconSize.width} ${_ctx.favoriteIconSize.height}`,
            "icon-color": "#c4c4c4",
            class: "p-item-empty-panel__icon"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconHeartOutline, {
                "icon-size": _ctx.favoriteIconSize.width
              }, null, 8, ["icon-size"])
            ]),
            _: 1
          }, 8, ["width", "height", "view-box"]))
        : _createCommentVNode("", true),
      (_ctx.type === 'history')
        ? (_openBlock(), _createBlock(_component_IconBase, {
            key: 1,
            width: _ctx.historyIconSize.width,
            height: _ctx.historyIconSize.height,
            "view-box": `0 0 ${_ctx.historyIconSize.width} ${_ctx.historyIconSize.height}`,
            "icon-color": "#c4c4c4",
            class: "p-item-empty-panel__icon"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconHistory, {
                "icon-size": _ctx.historyIconSize.width
              }, null, 8, ["icon-size"])
            ]),
            _: 1
          }, 8, ["width", "height", "view-box"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.text), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ButtonMain, {
        tag: 'a',
        href: "/product-list/"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("商品を探す", -1)
        ])),
        _: 1,
        __: [0]
      })
    ])
  ]))
}